<mat-toolbar color="primary" class="toolbarFixed">
    <mat-toolbar-row>
        <div fxFlex="250px" fxHide.lt-lg>
            <div fxLayout="column">
                <div fxLayout="row">
                    <div fxLayout fxLayoutGap="20px" class="marginLeft8">
                        <img src="./assets/jcu-logo.png" height="40" alt="" />
                    </div>
                    <h1 fxLayout fxLayoutGap="20px">John Cabot Student Portal</h1>
                </div>
            </div>
        </div>

        <div fxFlex="50px" *ngIf="isMobile">
            <div fxLayout="column">
                <div fxLayout="row">
                    <button mat-icon-button (click)="sideNavToggle()" *ngIf="!opened">
                        <mat-icon>menu</mat-icon>
                    </button>
                </div>
            </div>
        </div>
        <mat-list class="profileItem">
            <mat-list-item (click)="(currentUser.studentCode || currentUser.hasValidProgramCode) && accountProfile()" [ngClass]="{'cursorNormal': !currentUser.studentCode && !currentUser.hasValidProgramCode}" matTooltip="View Profile" [matTooltipDisabled]="!currentUser.studentCode && !currentUser.hasValidProgramCode">
                <img matListAvatar src="{{currentUser.imageSrc}}" alt="profile image" *ngIf="currentUser.imageSrc; else noImageIcon">
                <ng-template #noImageIcon>
                    <mat-icon class="profileIcon">account_circle</mat-icon>
                </ng-template>
                <h3 matLine class="toolbar-title" fxHide.lt-lg>{{currentUser.preferredName ? currentUser.preferredName : currentUser.firstName}} {{currentUser.lastName}} </h3>
            </mat-list-item>
        </mat-list>

        <div fxFlex fxLayout fxLayoutAlign="flex-end">
            <ul fxLayout fxLayoutGap="20px" class="navigation-items">
                <li>
                    <button mat-icon-button [disabled]="currentUser?.userNotifications?.length == 0" [matMenuTriggerFor]="notifications" #notificationsMenuTrigger="matMenuTrigger">
                        <mat-icon [matBadge]="currentUser?.userNotifications?.length" matBadgeColor="warn" matBadgeSize="medium" [matBadgeHidden]="currentUser?.userNotifications?.length == 0">notifications_active</mat-icon>
                    </button>
                    <mat-menu #notifications="matMenu" class="notificationsMenu menuPaneOverlay">
                        <button mat-menu-item *ngFor="let userNotification of currentUser.userNotifications" [disabled]="!userNotification.dialogBox && !userNotification.url" (click)="notificationRedirect(userNotification)" class="paddingLeft5">
                            <mat-icon class="notificationIcon">notification_important</mat-icon>
                            <span [innerHTML]="userNotification.message"></span>
                        </button>
                    </mat-menu>
                </li>
                <li>
                    <button mat-icon-button [matMenuTriggerFor]="settings">
                        <mat-icon>settings</mat-icon>
                    </button>
                    <mat-menu #settings="matMenu">
                        <button mat-menu-item (click)="changePassword()">
                            <mat-icon>lock</mat-icon>
                            <span>Change Password</span>
                        </button>
                    </mat-menu>
                </li>
                <li>
                    <button mat-icon-button [matMenuTriggerFor]="account">
                        <mat-icon>person_outline</mat-icon>
                    </button>
                    <mat-menu #account="matMenu">
                        <button mat-menu-item (click)="accountProfile()" [disabled]="!currentUser.studentCode">
                            <mat-icon>account_box</mat-icon>
                            <span>My Profile</span>
                        </button>
                        <button mat-menu-item (click)="logout()">
                            <mat-icon>exit_to_app</mat-icon>
                            <span>Sign out</span>
                        </button>
                    </mat-menu>
                </li>
            </ul>
        </div>
    </mat-toolbar-row>
</mat-toolbar>
